import React, { useEffect, useState } from "react";
import { Anchor, Box, DataTable, Page, PageContent, PageHeader, Spinner, Text } from "grommet";
import { useSelector } from "react-redux";
import { announcementService } from "../services";
import { isFullAdmin } from "../components/admin/roles";

const formatDate = (iso) => (iso ? new Date(iso).toLocaleString() : "—");
const isSafeUrl = (url) => typeof url === "string" && /^https?:\/\//i.test(url);

const columns = [
    { property: "created_at", header: "Submitted", size: "small", render: (f) => formatDate(f.created_at) },
    {
        property: "user_name",
        header: "User",
        size: "small",
        render: (f) => (
            <Box>
                <Text>{f.user_name || f.user_email || `User #${f.user}`}</Text>
                {f.user_name && f.user_email && <Text size="small" color="text-weak">{f.user_email}</Text>}
            </Box>
        ),
    },
    { property: "competitor_name", header: "Competitor", size: "small" },
    {
        property: "feedback",
        header: "Feedback",
        sortable: false,
        render: (f) => <Text style={{ whiteSpace: "pre-wrap" }}>{f.feedback}</Text>,
    },
    {
        property: "upload_document",
        header: "Document",
        size: "xsmall",
        sortable: false,
        render: (f) => (isSafeUrl(f.upload_document)
            ? <Anchor href={f.upload_document} target="_blank" rel="noopener noreferrer" label="Open" />
            : <Text color="text-weak">—</Text>),
    },
];

export const AdminUserFeedback = () => {
    const access = useSelector((state) => state.session.user && state.session.user.access);
    const fullAdmin = useSelector((state) => isFullAdmin(state.session.user));
    const [feedbacks, setFeedbacks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!access || !fullAdmin) return;
        setLoading(true);
        announcementService.getAdminUserFeedbacks(access)
            .then((data) => {
                setFeedbacks(Array.isArray(data) ? data : []);
                setError(null);
            })
            .catch((err) => setError(err.message))
            .finally(() => setLoading(false));
    }, [access, fullAdmin]);

    return (
        <Page>
            <PageContent gap="medium">
                <PageHeader title="User Feedback" subtitle={fullAdmin ? `${feedbacks.length} submission${feedbacks.length === 1 ? "" : "s"}` : undefined} />
                {!fullAdmin ? (
                    <Text>You are not authorised to view this.</Text>
                ) : loading ? <Spinner /> : error ? (
                    <Text color="status-critical">{error}</Text>
                ) : feedbacks.length === 0 ? (
                    <Text color="text-weak">No feedback yet.</Text>
                ) : (
                    <Box overflow={{ horizontal: "auto" }}>
                        <DataTable columns={columns} data={feedbacks} primaryKey="id" sortable paginate step={20} verticalAlign="top" />
                    </Box>
                )}
            </PageContent>
        </Page>
    );
};